import useGetter from "./useGetter";

export default function useWaiversRequests(teamId) {
  const enabled = !!teamId;
  const waiversRequestsUrl = `/rosters/requests/${teamId}`;
  const { data: waiversRequestsData, query: waiversRequestsQuery } = useGetter(
    waiversRequestsUrl,
    {
      enabled,
    }
  );

  return { waiversRequestsData, waiversRequestsQuery, waiversRequestsUrl };
}
